import { render, staticRenderFns } from "./SafetyHeaderNav.vue?vue&type=template&id=1ba3fbec&"
import script from "./SafetyHeaderNav.vue?vue&type=script&lang=js&"
export * from "./SafetyHeaderNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports